module.exports = __webpack_public_path__ + "static/media/thumb.703b8f02.png";